/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError, AxiosResponse } from 'axios'
import { toast } from 'sonner'

const API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://192.168.0.153:7055',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const API_BLOG = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://192.168.0.153:7055',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor request
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers = config.headers ?? {}
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)
API.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error: AxiosError | any) => {
    if (error.response) {
      const { status } = error.response
      const errorMessage = error.response.data?.message || (`An unexpected error occurred` as any)

      if (status === 401) {
        toast.error(`Unauthorized (401): Token expired or invalid`)
      } else if (status >= 400 && status < 500) {
        toast.error(`Client Error (${status}): ${errorMessage}`)
      } else if (status >= 500) {
        toast.error(`Server Error (${status}): ${errorMessage}`)
      }
    } else if (error.request) {
      toast.error(`No response received: Network error or server unavailable`)
    } else {
      toast.error(`Error: ${error.message}`)
    }
    return Promise.reject(error)
  }
)

export default API
